import { DomainError } from './types/DomainError';
import { isDomainData, isDomainError } from './utils';
import { ErrorCode, GetchErrorCode } from '@golden/gdk-base';
import { getch, makeImageRequest, makeDomainRequest } from './getch';
import { catchError, forkJoin, from, map, of, switchMap } from 'rxjs';
export function checkImage(urlHelper, ms = 5000) {
    const baseURL = `${urlHelper.get('main')}${urlHelper.clientProtocol === 'https:' ? '/m' : ''}`;
    return getch.send(makeImageRequest(baseURL, ms)).pipe(switchMap((res) => {
        const data = res.data;
        if (data.type !== 'image/png' || data.size < 20000) {
            throw new DomainError('ResponseBody', baseURL, { res, data });
        }
        return of(true);
    }), catchError((err) => {
        const error = err;
        if (!isDomainError(error)) {
            if (error.code === GetchErrorCode.STATUS_CODE) {
                throw new DomainError('StatusCode', baseURL, { res: error, data: error.response.data });
            }
            if (error.code === GetchErrorCode.TIMEOUT) {
                throw new DomainError('Timeout', baseURL, { res: error });
            }
            throw new DomainError('Unknown', baseURL, undefined, error);
        }
        throw error;
    }));
}
export function checkAPI(urlHelper, scope, version, queries = '') {
    const baseURL = `${urlHelper.get('api')}/${scope}/${version}`;
    return getch.send(makeDomainRequest(baseURL, 5000, queries)).pipe(switchMap((res) => {
        const data = res.data;
        if (!isDomainData(data)) {
            throw new DomainError('ResponseBody', baseURL, { res, data });
        }
        return of(data);
    }), catchError((err) => {
        const error = err;
        if (!isDomainError(error)) {
            if (error.code === GetchErrorCode.STATUS_CODE) {
                const data = error.response.data;
                if (error.response.status === 403 && data.code === ErrorCode.IP_NOT_IN_WHITELIST) {
                    throw new DomainError('Forbidden', baseURL, { res: error, data });
                }
                if (error.response.status === 400 && data.code === ErrorCode.PLAYER_MAINTENANCE) {
                    throw new DomainError('Maintenance', baseURL, { res: error, data });
                }
                throw new DomainError('StatusCode', baseURL, { res: error, data: error.response.data });
            }
            if (error.code === GetchErrorCode.TIMEOUT) {
                throw new DomainError('Timeout', baseURL, { res: error });
            }
            throw new DomainError('Unknown', baseURL, undefined, error);
        }
        throw error;
    }));
}
export function checkDomain(urlHelper, queries = '') {
    return forkJoin([checkImage(urlHelper), checkAPI(urlHelper, 'player', 'v1', queries)]);
}
// no-cors request can't call with xhr.
export function checkNetwork() {
    return of(!window.navigator.onLine).pipe(switchMap((offline) => {
        if (offline)
            return of(false);
        return from(fetch('https://im.qq.com/', { mode: 'no-cors', cache: 'no-store' })).pipe(map(() => true), catchError(() => of(false)));
    }));
}
//# sourceMappingURL=check.js.map